import {loader} from './loader'

export default function reveal() {
  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  $(document).on('click', '.reveal-link', function(e){
    e.preventDefault();
    let $this = $(this),
      product_id = $this.data('product-id');

    $this.prop("disabled", true);

    $.ajax({
      url: window.reveal.ajaxurl,
      method: 'POST',
      dataType: 'json',
      data: {
        action: 'reveal_request',
        _ajax_nonce: window.reveal.nonce,
        product_id: product_id
      },
      beforeSend: function(){
        loader.show()
      },
      success: function (response) {
        loader.hide()
        $this.prop("disabled", false);

        if (response.status === 'noauth') {
          $('body').append(response.modal);

          $('.modal').modal().on('hidden.bs.modal', function (e) {
            $(this).remove();
          });
        }
        if (response.status === 'success') {
          let currency = response.currency,
            scholarship = numberWithCommas(response.scholarship),
            tuition = numberWithCommas(response.tuition),
            cont = $this.closest('.reveal-wrap'),
            tuitionTitle = cont.data('title-tuition'),
            scholarshipTitle = cont.data('title-scholarship');

          cont.find('.scholarship > button').remove();
          cont.find('.tuition_from > button').remove();

          if (scholarship === '0' || scholarship === '' || scholarship === null) {
            cont.find('.scholarship').append(`<div class="btn-reveal">
                <div class="price-title">No Scholarship Available</div>
                <div class="price-value"><span class="price-title">At This Time</span></div>
            </div>`);
            cont.find('.tuition_from').remove();
          } else {
            cont.find('.scholarship').append(`<div class="btn-reveal">
                <div class="price-title">${scholarshipTitle}</div>
                <div class="price-value">${currency + scholarship}</div>
            </div>`);

            cont.find('.tuition_from').append(`<div class="btn-reveal">
                <div class="price-title">${tuitionTitle}</div>
                <div class="price-value">${currency + tuition}</div>
            </div>`);

            cont.find('.tuition .price-value').addClass('strike');
          }

          cont.find('.price-reveal').remove();
        }

      },
      error: function(error){
        loader.hide()
        $this.prop("disabled", false);
        console.log(error);
      }
    });
  });
}